module.exports = __webpack_public_path__ + "img/image11@3x.6b4713e6.png";